/**
 * Included into the footer of pages.
 */
import './lib/AnimationEasing';
import {videoModals} from "./component/VideoModal/VideoModal";
videoModals({
	// If you want a custom play button, uncomment this line
	// customPlayButton: require("./component/VideoModal/VideoModal.svg?string")
});



// ================================================================================================
// Hides sections on Newsroom page if either is on Query page 2 or higher.
// ================================================================================================
const handleNewsroomPagination = () => {
    if (window.location.pathname.includes('/newsroom')) {
        const urlParams = new URLSearchParams(window.location.search);
        let shouldHideSeparator = false;
        
        // Hide the Media Coverage section.
        const mediaPageNumber = parseInt(urlParams.get('query-4-page') || '1');
        if (mediaPageNumber >= 2) {
            const mediaCoverageSection = document.querySelector('.plauditQueryLoop--media-coverage') as HTMLElement;
            if (mediaCoverageSection) {
                mediaCoverageSection.style.display = 'none';
                shouldHideSeparator = true;
            }
        }

        // Hide the Articles section.
        const articlesPageNumber = parseInt(urlParams.get('query-8-page') || '1');
        if (articlesPageNumber >= 2) {
            const articlesSection = document.querySelector('.plauditQueryLoop--articles') as HTMLElement;
            if (articlesSection) {
                articlesSection.style.display = 'none';
                shouldHideSeparator = true;
            }
        }

        // Hides the separator if either section is hidden.
        if (shouldHideSeparator) {
            const separator = document.querySelector('.wp-block-separator') as HTMLElement;
            if (separator) {
                separator.style.display = 'none';
            }
        }
    }
};
document.addEventListener('DOMContentLoaded', handleNewsroomPagination);



// ================================================================================================
// Checks if current page is Post or Resource post type and handles author styling
// ================================================================================================
const handleAuthorStyling = () => {
    // Check if we're on a Post/Resource post type
    const isPostType = document.body.classList.contains('single-post') || document.body.classList.contains('single-resource');
    
    if (isPostType) {
        const authorElement = document.querySelector('.wp-block-post-author') as HTMLElement;
        
        if (authorElement) {
            const authorNameElement = authorElement.querySelector('.wp-block-post-author__name a') as HTMLAnchorElement;
            
            if (authorNameElement && authorNameElement.textContent?.trim() === 'St. Croix Hospice') {
                authorElement.classList.add('has-no-resources');
            }
        }
    }
};

document.addEventListener('DOMContentLoaded', handleAuthorStyling);


// ---------------------------------------------------------------------------------------------- //
// Animations
//
// SEE EXAMPLE BELOW:
//
// import InViewObserver from './lib/InViewObserver';
// InViewObserver.createInstance(
// 	{
// 		observeSelector: '.pageContent > .wp-block-group, .callToAction, .site-footer__content',
// 		minimum: 20,
// 		minimumUnit: "px"
// 	},
// 	{
// 		observeSelector: '.decorativeShape__canvas, .site-footer__donutCanvas',
// 		minimum: 20,
// 		minimumUnit: "px"
// 	}
// );
// ---------------------------------------------------------------------------------------------- //


